// domain/constants/measurementMetric.js

/**
 * How a target's collected data is summarised into a number.
 *
 * A PROGRAM CARRIES ONE AND A TARGET MAY OVERRIDE IT, with an unset target reading the program's.
 * The labels live with `PROGRAM_IMPORTABLE_FIELDS`, which needs them keyed to i18n; these are the
 * identities.
 *
 * @domainObject value-object
 * @typedef {'percentCorrect'|'frequency'|'totalDuration'|'minDuration'|'maxDuration'
 *   |'avgDuration'|'ratePerMinute'|'ratePerHour'} MeasurementMetric
 */
// eslint-disable-next-line import/prefer-default-export
export const MEASUREMENT_METRIC = {
  PERCENT_CORRECT: 'percentCorrect',
  FREQUENCY: 'frequency',
  TOTAL_DURATION: 'totalDuration',
  MIN_DURATION: 'minDuration',
  MAX_DURATION: 'maxDuration',
  AVG_DURATION: 'avgDuration',
  RATE_PER_MINUTE: 'ratePerMinute',
  RATE_PER_HOUR: 'ratePerHour',
};
